/**
 * AJAX Cart Logic for Ty'Jamin Theme
 * Handles add-to-cart, drawer toggling, and cart updates
 */

// Format money helper
function formatMoney(cents) {
  return '$' + (cents / 100).toFixed(2);
}

// Open/Close Drawer
function openCartDrawer() {
  const drawer = document.getElementById('cart-drawer');
  if (drawer) {
    drawer.classList.add('is-open');
    document.body.style.overflow = 'hidden'; // Prevent background scrolling
  }
}

function closeCartDrawer() {
  const drawer = document.getElementById('cart-drawer');
  if (drawer) {
    drawer.classList.remove('is-open');
    document.body.style.overflow = '';
  }
}

// Fetch and Render Cart
async function updateCartDrawer() {
  try {
    const response = await fetch('/cart.js');
    const cart = await response.json();
    
    // Update count
    const countElements = document.querySelectorAll('#cart-count');
    countElements.forEach(el => el.textContent = cart.item_count);
    
    // Update total
    const totalElement = document.getElementById('cart-drawer-total');
    if (totalElement) totalElement.textContent = formatMoney(cart.total_price);

    // Enable/disable checkout button when cart is empty
    const checkoutBtn = document.querySelector('.cart-drawer__checkout-btn');
    if (checkoutBtn) {
      const isEmpty = cart.item_count === 0;
      checkoutBtn.disabled = isEmpty;
      checkoutBtn.setAttribute('aria-disabled', String(isEmpty));
      checkoutBtn.style.opacity = isEmpty ? '0.5' : '';
      checkoutBtn.style.pointerEvents = isEmpty ? 'none' : '';
    }
    
    // Render items
    const itemsContainer = document.getElementById('cart-drawer-items');
    if (!itemsContainer) return;
    
    if (cart.items.length === 0) {
      itemsContainer.innerHTML = '<div class="cart-drawer__empty">Your cart is empty</div>';
    } else {
      itemsContainer.innerHTML = cart.items.map(item => `
        <div class="cart-drawer__item" data-key="${item.key}">
          <div class="cart-drawer__item-image">
            <a href="${item.url}">
              <img src="${item.image}" alt="${item.title}">
            </a>
          </div>
          <div class="cart-drawer__item-details">
            <div>
              <a href="${item.url}" class="cart-drawer__item-title">${item.product_title}</a>
              ${item.variant_title ? `<div class="cart-drawer__item-variant">${item.variant_title}</div>` : ''}
              <div class="cart-drawer__item-price">${formatMoney(item.price)}</div>
            </div>
            <div class="cart-drawer__item-controls">
              <div class="cart-drawer__qty">
                <button class="cart-drawer__qty-btn" data-action="decrease" data-key="${item.key}" data-quantity="${item.quantity}">-</button>
                <input type="text" class="cart-drawer__qty-input" value="${item.quantity}" readonly>
                <button class="cart-drawer__qty-btn" data-action="increase" data-key="${item.key}" data-quantity="${item.quantity}">+</button>
              </div>
              <button class="cart-drawer__remove" data-action="remove" data-key="${item.key}">Remove</button>
            </div>
          </div>
        </div>
      `).join('');
    }
  } catch (error) {
    console.error('Error updating cart:', error);
  }
}

// Change Quantity
async function changeQuantity(key, quantity) {
  try {
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    });
    updateCartDrawer();
  } catch (error) {
    console.error('Error changing quantity:', error);
  }
}

// Event Delegation for Cart Drawer
document.addEventListener('DOMContentLoaded', () => {
  const cartDrawerItems = document.getElementById('cart-drawer-items');
  
  if (cartDrawerItems) {
    cartDrawerItems.addEventListener('click', (e) => {
      const target = e.target.closest('button');
      if (!target) return;
      
      // Handle Decrease
      if (target.matches('[data-action="decrease"]')) {
        const key = target.dataset.key;
        const quantity = parseInt(target.dataset.quantity) - 1;
        changeQuantity(key, quantity);
      }
      
      // Handle Increase
      if (target.matches('[data-action="increase"]')) {
        const key = target.dataset.key;
        const quantity = parseInt(target.dataset.quantity) + 1;
        changeQuantity(key, quantity);
      }
      
      // Handle Remove
      if (target.matches('[data-action="remove"]')) {
        const key = target.dataset.key;
        changeQuantity(key, 0);
      }
    });
  }

  // Add to Cart Handler
  const addToCartForm = document.getElementById('product-form');
  
  if (addToCartForm) {
    addToCartForm.addEventListener('submit', async (e) => {
      e.preventDefault();
      
      const submitBtn = addToCartForm.querySelector('button[type="submit"]');
      const originalText = submitBtn.innerHTML;
      submitBtn.disabled = true;
      submitBtn.innerHTML = 'Adding...';
      
      // Get Variant ID explicitly
      const variantIdInput = document.getElementById('product-selected-variant');
      const variantId = variantIdInput ? variantIdInput.value : null;

      if (!variantId) {
        alert('Please select a variant.');
        submitBtn.disabled = false;
        submitBtn.innerHTML = originalText;
        return;
      }
      
      try {
        // Use x-www-form-urlencoded which is the most compatible way to hit Shopify's AJAX cart API
        // (Some storefront setups return errors when sending JSON to /cart/add.js.)
        const params = new URLSearchParams();
        params.set('id', String(variantId).trim());
        params.set('quantity', '1');

        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
            'Accept': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: params.toString()
        });
        
        if (response.ok) {
          await updateCartDrawer();
          openCartDrawer();
        } else {
          // Shopify usually responds with JSON, but fall back gracefully.
          let errorData = null;
          try { errorData = await response.json(); } catch (e) {}
          const message = (errorData && (errorData.description || errorData.message))
            ? (errorData.description || errorData.message)
            : `HTTP ${response.status}`;
          alert('Error adding to cart: ' + message);
        }
      } catch (error) {
        console.error('Error submitting form:', error);
        alert('There was an error adding the item to your cart.');
      } finally {
        submitBtn.disabled = false;
        submitBtn.innerHTML = originalText;
      }
    });
  }
  
  // Initial cart load
  updateCartDrawer();
});

// Variant Selection Logic (re-implemented from V9 fix)
function selectVariant(btn, optionName) {
  // 1. Update UI
  const container = btn.closest('.selector-wrapper');
  const siblings = container.querySelectorAll('.variant-btn');
  siblings.forEach(el => el.classList.remove('selected'));
  btn.classList.add('selected');
  
  // 2. Get all selected options
  const form = document.getElementById('product-form');
  const selectedOptions = Array.from(form.querySelectorAll('.variant-btn.selected')).map(el => el.dataset.value);
  
  // 3. Find matching variant from product data
  // Note: 'product' variable must be defined in the liquid template
  if (typeof product !== 'undefined') {
    const matchedVariant = product.variants.find(variant => {
      return variant.options.every((option, index) => option === selectedOptions[index]);
    });
    
    if (matchedVariant) {
      // Update hidden input
      const idInput = document.getElementById('product-selected-variant');
      if (idInput) idInput.value = matchedVariant.id;
      
      // Update price
      const priceDisplay = document.querySelector('.product-price');
      if (priceDisplay) {
        priceDisplay.textContent = formatMoney(matchedVariant.price);
      }
      
      // Update button state
      const addBtn = document.getElementById('product-form').querySelector('button[type="submit"]');
      const addText = addBtn; // Simplified as the button text is direct content
      
      if (matchedVariant.available) {
        addBtn.disabled = false;
        addText.textContent = 'Add to Cart';
      } else {
        addBtn.disabled = true;
        addText.textContent = 'Sold Out';
      }
    }
  }
}
